import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import GoogleFontLoader from "react-google-font-loader";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const signFonts = [
  { font: "AlexBrush" },
  { font: "Caveat" },
  { font: "DancingScript" },
  { font: "GreatVibes" },
  { font: "Inspiration" },
  { font: "Parisienne" },
  { font: "Sacramento" },
  { font: "Tangerine" },
  { font: "Yellowtail" },
  { font: "SquarePeg" },
];

const colors = [
  { color: "black" },
  { color: "green" },
  { color: "blue" },
  { color: "red" },

];

const signFontSizes = [
  { id: 1, name: 20 },
  { id: 2, name: 30 },
  { id: 3, name: 40 },
  { id: 3, name: 50 },
  { id: 3, name: 60 },
];

export default function SignPopup({
  handleClose,
  open,
  handleSaveSign,
  handleSaveDate,
  selectedObj,
}) {
  const [value, setValue] = useState(0);
  const [signText, setSignText] = useState("");
  const [signFont, setSignFont] = useState("");
  const [signFontSize, setSignFontSize] = useState(16);
  const [selectedColor, setSelectedColor] = useState("black");

  useEffect(() => {
    setSignText(selectedObj.name);
    setSignFont(selectedObj.font);
    setSignFontSize(selectedObj.size);
    if (selectedObj?.type === "date") {
      const curDt = new Date(selectedObj.date);
      let dd = curDt.getDate();
      if (dd < 10) dd = "0" + dd;
      let mm = curDt.getMonth() + 1;
      if (mm < 10) mm = "0" + mm;
      let yy = curDt.getFullYear();
      setValue(`${yy}-${mm}-${dd}`);
    }
  }, [selectedObj]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSignText = (event) => {
    setSignText(event.target.value);
  };

  const handleSignStyleChange = (event) => {
    setSignFont(event.font);
  };

  const handleSave = () => {
    const signObj = {
      id: selectedObj.id,
      name: signText,
      font: signFont,
      fontSize: signFontSize,
      fontColor: selectedColor.color,
      type: "sign",
      x: selectedObj.x,
      y: selectedObj.y,
    };
    handleSaveSign(signObj);
  };

  const handleSaveText = () => {
    let newTxtObj = { ...selectedObj };
    newTxtObj.name = signText;
    newTxtObj.fontSize = selectedObj.size;
    handleSaveSign(newTxtObj);
  };

  const handleDtObj=()=>{
    let newDtObj={...selectedObj};
     const curDt = new Date(value);
      let dt = "";
      let dd = curDt.getDate();
      if (dd < 10) dd = "0" + dd;
      let mm = curDt.getMonth() + 1;
      if (mm < 10) mm = "0" + mm;
      const yy = curDt.getFullYear();
      dt = mm + "-" + dd + "-" + yy;
    newDtObj.date=dt;
    handleSaveDate(newDtObj);
  }

  const handleSizeChange = (event) => {
    setSignFontSize(event.target.value);
  };

  const handleDateChange = (e) => {
    const raw = e.target.value; // "2025-08-26"
    setValue(raw);
  };

  // format function
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`; // mm/dd/yyyy
  };

  return (
    <div>
      <GoogleFontLoader fonts={signFonts} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="lg"
        fullWidth
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {selectedObj?.type === "date" && "Select Date"}
          {selectedObj?.type === "text" && "Enter Text"}
          {selectedObj?.type !== "text" && selectedObj?.type !== "date" && "Add Signature"}
         
        </BootstrapDialogTitle>
        {selectedObj?.type === "date" && (
          <DialogContent dividers>
            <Box sx={{ borderBottom: 0, borderColor: "divider", p: 5 }}>
              <TextField
                label="Select Date"
                type="date"
                value={value}
                onChange={handleDateChange}
                InputLabelProps={{ shrink: true }}
                helperText={formatDate(value)}
                FormHelperTextProps={{
                  sx: { color: "white" },
                }}
                fullWidth
              />
            </Box>
          </DialogContent>
        )}
        {selectedObj?.type === "text" && (
          <DialogContent dividers>
            <Box sx={{ borderBottom: 0, borderColor: "divider", p: 5 }}>
              <TextField
                id="standard-basic"
                label="Input Here"
                variant="outlined"
                onChange={handleSignText}
                value={signText}
                fullWidth
              />
            </Box>
          </DialogContent>
        )}
        {selectedObj?.type !== "date" && selectedObj?.type !== "text" && (
          <DialogContent dividers>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Type" {...a11yProps(0)} />
                <Tab label="Draw" {...a11yProps(1)} />
                <Tab label="Image" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid container spacing={2} style={{ marginTop: 20 }}>
                <Grid xs={7} sx={{ marginLeft: "13px" }}>
                  <TextField
                    id="standard-basic"
                    label="Input Here"
                    variant="outlined"
                    onChange={handleSignText}
                    value={signText}
                    fullWidth
                  />
                </Grid>
                <Grid xs={4} sx={{ marginLeft: "auto" }}>
                  <FormControl fullWidth>
                    <InputLabel id="fontSize">Font Size</InputLabel>
                    <Select
                      labelId="fontSize"
                      id="fontSize"
                      value={signFontSize}
                      label="Size"
                      onChange={handleSizeChange}
                    >
                      {signFontSizes.map((item) => (
                        <MenuItem value={item.name}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                style={{ marginBottom: 20, marginTop: 20 }}
              >
                {signFonts.map((design, index) => (
                  <Grid item xs={6} sm={4} key={index}>
                    <Box
                      onClick={() => handleSignStyleChange(design)}
                      style={{
                        border:
                          signFont === design?.font
                            ? "2px solid blue"
                            : "1px solid black",
                        backgroundColor:
                          signFont === design?.font ? "#def4ef" : "white",
                        marginTop: 2,
                        marginBottom: 2,
                        padding: 10,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: design.font,
                          color: selectedColor.color,
                          fontSize: signFontSize,
                        }}
                      >
                        {signText || "Sample"}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={2}>
              Item Three
            </TabPanel>
          </DialogContent>
        )}
        <DialogActions>
          {selectedObj?.type !== "date" && selectedObj?.type !== "text" && (
            <Grid container spacing={2}>
              <Grid item xs={8} sx={{ marginLeft: "23px" }}>
                <Grid container spacing={1}>
                  {colors.map((color, idx) => (
                    <Grid item key={idx}>
                      <div
                        onClick={() => setSelectedColor(color)}
                        style={{
                          backgroundColor: color?.color,
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          border:
                            selectedColor === color?.color
                              ? "2px solid white"
                              : "1px solid gray",
                          cursor: "pointer",
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Button
            onClick={selectedObj?.type === "date" ? handleDtObj : selectedObj?.type === "text" ? handleSaveText : handleSave}
          >
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
